export const colors = {
  black: "#000000",
  orange: "#ff751d",
  orangeLight: "#ffdac0",

  white: "#ffffff",
  textColor: "#52555f",
  /* 70% прозрачность текста */
  // textColorSecond: "rgb(82, 85, 95, 70%)", - below the same color, just in another color-scheme
  textColorSecond: "#52555fb3",

  logoBg: "#f5f6fa",

  inputBg: "#f6f7fb",
  bgModal: "#1d346a",
  bgModalBalance: "linear-gradient(117.84deg, #1D346A 2.84%, #031634 67.28%)",
  /* Цвет для бэкграунда во вкладке "Доход" или "Расход" */
  bgSummary: "#f5f6fb",

  //   /* Цвет для неактивной вкладки "Доход" или "Расход" */
  bgBtnActive: "#fcfdfd",
  bgBtnPrimary: "#f8f9fb",
  bgBtn: "#fafbfd",
  bgMainNav: "#fbfcfc",
  // Цвет вертикальной палочки в блоке Расходы/Доходы на странице Статистики
  lineColor: "#E0E5EB",

  // Цвета расхода и дохода на странице Статистики
  redColor: "#E53935",
  greenColor: "#407946",

  // Цвет border кнопки Очистить на tablet
  borderClearBtnColor: "#f6f7fc",

  // Цвет внутри select
  selectColor: "#C7CCDC",

  // Placeholder Auth Form
  authText: "#a6abb9",

  // Border bottom modal
  modalBorder: "#172d5d",

  bgTopAuth: "#f2f5fc",

  animation: "250ms cubic-bezier(0.4, 0, 0.2, 1)",
};

//   --costs-color: #e53935,
//   /* Расход */
//   --income-color: #407946,

//   /* 20% прозрачность цвета */
//   --main-second-orange-color: rgb(251, 124, 47, 20%),
//   --mail-error-color: red,
//   --main-grey-bg-color: #f2f5fc,

// }
